import TextMarkerSymbol from './TextMarkerSymbol';
import GeometryFactory from '../geometry/GeometryFactory';

/**
 * 文字加背景色symbol
 */
export default class TextBackgroundSymbol extends TextMarkerSymbol {
    constructor(options) {
        super(options);

        this.bgColor = 'white'; // 背景色
        this.borderColor = 'black'; // 边框颜色
        this.borderWidth = 1.5; // 边框宽度

        this.fromJson(options);
    }

    fromJson(json) {
        super.fromJson(json);

        this._setValue('bgColor', json.bgColor);
        this._setValue('borderColor', json.borderColor);
        this._setValue('borderWidth', json.borderWidth);
    }

    toJson() {
        const json = super.toJson();

        json.bgColor = this.bgColor;
        json.borderColor = this.borderColor;
        json.borderWidth = this.borderWidth;

        return json;
    }

    /**
     * 重写父类方法,以文字绘制点符号.
     * @param {Object} ctx - 设备上下文,通过canvas.getContext('2d')方法获得.
     * @return {undefined}
     */
    _drawContent(ctx) {
        // 字体宽度
        ctx.font = `${this.size}px ${this.font}`;
        const m = ctx.measureText(this.text);
        const strH = m.actualBoundingBoxAscent + m.actualBoundingBoxDescent;
        // 背景矩形 背景色
        ctx.fillStyle = this.bgColor;
        ctx.fillRect(-(m.width + 10) / 2, 1, m.width + 10, strH + 5);
        // 边框矩形 颜色宽度 
        ctx.strokeStyle = this.borderColor;
        ctx.lineWidth = this.borderWidth;
        // x轴负自身一半， width文字本身长度加空白
        ctx.strokeRect(-(m.width + 10) / 2, 1, m.width + 10, strH + 5);

        // 设置绘制环境
        ctx.font = `${this.size}px ${this.font}`;
        ctx.textAlign = this.align;
        ctx.textBaseline = this.baseline;
        ctx.direction = this.direction;
        ctx.fillStyle = this.color;
        ctx.globalAlpha = this.opacity;
    
        // 绘制
        ctx.fillText(this.text, 0, 8);
    }
}
